import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import '@fontsource/barlow-semi-condensed/400.css';
import '@fontsource/barlow-semi-condensed/500.css';
import '@fontsource/barlow-semi-condensed/600.css';
import '@fontsource/barlow-semi-condensed/700.css';
import '@fontsource/barlow-semi-condensed/800.css';
import '@fontsource/ibm-plex-mono/400.css';
import '@fontsource/ibm-plex-mono/500.css';
import '@fontsource/ibm-plex-mono/700.css';
import './estilos.css';
import './c21.css';

createRoot(document.getElementById('raiz')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Sin «Información guardada» del navegador en los campos del ERP (pedido de Rodrigo, 2026-10-22):
// cantidades, precios y búsquedas no se autocompletan con lo digitado antes. Un campo que declara su
// propio autocomplete (usuario y clave del login) lo conserva.
const sinAutocompletar = (raiz: ParentNode) => {
  for (const el of raiz.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>(
    'input:not([autocomplete]), textarea:not([autocomplete])',
  ))
    el.setAttribute('autocomplete', 'off');
};
sinAutocompletar(document);
new MutationObserver(() => sinAutocompletar(document)).observe(document.body, {
  childList: true,
  subtree: true,
});

// F7 es un atajo del ERP (últimas compras): en Edge/Chrome también activa la «navegación con cursor
// de texto», que deja un cursor para escribir sobre textos que no se editan (Rodrigo, 2026-10-23).
// Nunca llega al navegador.
window.addEventListener(
  'keydown',
  (e) => {
    if (e.key === 'F7') e.preventDefault();
  },
  true,
);
